module.exports = __webpack_public_path__ + "img/hero-feature.334c7863.png";